import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  LOGGED_IN_USER_DATA,
  CURRENT_ORG,
  CURRENT_ORG_IDENTIFIER,
} from "../config/constants";

const useUserStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      organization: null,
      isAuthenticated: false,

      // Set user data after successful authentication
      setUser: (userData) => {
        set({
          user: userData,
          isAuthenticated: true,
        });

        // Also store in localStorage for compatibility with existing code
        localStorage.setItem(LOGGED_IN_USER_DATA, JSON.stringify(userData));
      },

      // Set authentication token
      setToken: (token) => {
        set({ token });
        // Also store in localStorage for compatibility with existing code
        localStorage.setItem("authToken", token);
      },

      // Set current organization
      setOrganization: (org) => {
        set({ organization: org });
        // Also store in localStorage for compatibility with existing code
        if (org) {
          localStorage.setItem(CURRENT_ORG, JSON.stringify(org));
          localStorage.setItem(CURRENT_ORG_IDENTIFIER, org.identifier);
        }
      },

      // Handle OTP verification response
      handleAuthResponse: (response) => {
        const { data, token } = response;

        // Set user data
        if (data) {
          set({
            user: data,
            isAuthenticated: true,
          });
          localStorage.setItem(LOGGED_IN_USER_DATA, JSON.stringify(data));

          // If data exists but doesn't have organizations, create an empty array
          if (!data.organizations) {
            data.organizations = [];
          }
        }

        // Set token if available
        if (token) {
          set({ token });
          localStorage.setItem("authToken", token);
        }

        // Set organization if available
        if (data?.organizations && data.organizations.length > 0) {
          const org = data.organizations[0];
          set({ organization: org });
          localStorage.setItem(CURRENT_ORG, JSON.stringify(org));
          localStorage.setItem(CURRENT_ORG_IDENTIFIER, org.identifier);
        } else if (data) {
          // If there are no organizations, set organizations to an empty array to prevent errors
          const updatedUser = {
            ...data,
            organizations: data.organizations || [],
          };
          set({ user: updatedUser });
          localStorage.setItem(
            LOGGED_IN_USER_DATA,
            JSON.stringify(updatedUser)
          );
        }
      },

      // Logout user
      logout: () => {
        set({
          user: null,
          token: null,
          organization: null,
          isAuthenticated: false,
        });

        // Clear localStorage items
        localStorage.removeItem(LOGGED_IN_USER_DATA);
        localStorage.removeItem(CURRENT_ORG);
        localStorage.removeItem(CURRENT_ORG_IDENTIFIER);
        localStorage.removeItem("authToken");
      },
    }),
    {
      name: "user-storage", // unique name for localStorage
      getStorage: () => localStorage, // storage type
    }
  )
);

export default useUserStore;
